import React, { useEffect, useLayoutEffect, useState } from 'react';

import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';

import { changePassword } from '../KairosEndpoint.js';



const ChangePassword = ({
	cancel,
	showInfo,
}) => {
	const [password, setPassword] = useState();
	const [newPassword, setNewPassword] = useState();

	const handleChangePassword = async () => {
		try {
			const result = await changePassword(password, newPassword);
			setPassword();
			setNewPassword();
			showInfo.show(null, 'Passwort geändert');
		}
		catch (e) {
			console.log(`error: ${e}`);
			showInfo.show('Fehler:', e);
		}
	};

	const onSubmit = ev => {
		ev.preventDefault();

		if (!ev.currentTarget.checkValidity())
            ev.stopPropagation();
		else
			handleChangePassword();
	};

	const onCancel = ev => {
		ev.preventDefault();
		cancel();
	};

	// render

	return (
		<div className = {'change-password'}>
			<Form
				noValidate
				validated = {true}
				onSubmit = {onSubmit}>

				{/* password */}
				<InputGroup
					hasValidation
					key = {'password'}>
					<InputGroup.Text>
						{'Aktuelles Passwort'}
					</InputGroup.Text>
					<FormControl
						type = {'password'}
						required = {true}
						name = {'password'}
						value = {password || ''}
						onChange = {ev => {
							ev.preventDefault();
							setPassword(ev.target.value);
						}}/>
				</InputGroup>

				{/* new password */}
				<InputGroup
					hasValidation
					key = {'newPassword'}>
					<InputGroup.Text>
						{'Neues Passwort'}
					</InputGroup.Text>
					<FormControl
						type = {'password'}
						required = {true}
						name = {'newPassword'}
						value = {newPassword || ''}
						onChange = {ev => {
							ev.preventDefault();
							setNewPassword(ev.target.value);
						}}/>
				</InputGroup>

				{/* update */}
				<Button
					type = {'submit'}>
					{'Übernehmen'}
				</Button>
				<Button
					onClick = {onCancel}>
					{'Abbrechen'}
				</Button>
			</Form>
		</div>
	);
};

export default ChangePassword;
